import React from "react";

export interface BtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children?: React.ReactNode;
}

const Btn= React.forwardRef<HTMLButtonElement, BtnProps>(({ className = "", children, ...props }, ref) => {
  // Kết hợp class 'btn' với className truyền vào
  const combinedClassName = `btn ${className ? " " + className : ""}`;
  return (
    <button ref={ref} className={combinedClassName} {...props}>
      {children}
    </button>
  );
});

export default Btn;
